// File: src/components/StaffingSmartCard.jsx
import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Users, Clock } from 'lucide-react';
import axios from 'axios';
import { useUserPermissions } from '@/hooks/useUserPermissions';
import { useNavigate } from 'react-router-dom';

const StaffingSmartCard = () => {
  const [summary, setSummary] = useState({ total_booked: 0, attended: 0 });
  const { canViewStaffingSummary } = useUserPermissions();
  const navigate = useNavigate();

  useEffect(() => {
    if (!canViewStaffingSummary) {
      navigate('/unauthorized');
      return;
    }

    const fetchSummary = async () => {
      try {
        const res = await axios.get('/solo-mdsh-api/staffing/staffing-summary');
        setSummary(res.data);
      } catch (err) {
        console.error('Error fetching staffing summary:', err);
      }
    };

    fetchSummary();
  }, [canViewStaffingSummary, navigate]);

  if (!canViewStaffingSummary) return null;

  const { total_booked, attended } = summary;
  const attendanceRate =
    total_booked > 0 ? ((attended / total_booked) * 100).toFixed(1) : '0.0';

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      whileHover={{ scale: 1.02 }}
      className="bg-gradient-to-br from-[#172032] to-[#1f2937] backdrop-blur-md border border-white/10 rounded-2xl p-5 shadow-lg hover:shadow-2xl transition-all"
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-white">👥 Staffing Summary</h3>
        <Users className="text-blue-400" />
      </div>

      <div className="space-y-2 text-sm text-white/80">
        <p>
          <span className="text-white font-bold">Booked Today:</span>{' '}
          {total_booked} shifts
        </p>
        <p>
          <span className="text-white font-bold">Attended:</span>{' '}
          {attended} shifts
        </p>
        <p className="text-cyan-400 font-medium flex items-center gap-2">
          <Clock size={16} /> Attendance Rate: {attendanceRate}%
        </p>
      </div>
    </motion.div>
  );
};

export default StaffingSmartCard;
